export default __webpack_public_path__ + "static/media/equalizer.4864fe54.svg";